import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { passwordSchema } from '@authsemply/shared';
import { AuthCard } from '../components/AuthCard';
import { NouveauMotDePasse } from '../components/NouveauMotDePasse';
import { Alert } from '../components/Alert';
import { api } from '../lib/api';

export function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [pending, setPending] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);

    const donnees = new FormData(event.currentTarget);
    const password = String(donnees.get('password') ?? '');
    const confirmation = String(donnees.get('confirmation') ?? '');
    const parsed = passwordSchema.safeParse(password);
    if (!parsed.success) {
      setError(`Mot de passe : ${parsed.error.issues[0]?.message ?? 'trop faible'}.`);
      return;
    }
    if (password !== confirmation) {
      setError('Les deux saisies du mot de passe ne sont pas identiques.');
      return;
    }

    setPending(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      setDone(true);
    } catch {
      setError('Ce lien est invalide ou a expiré.');
    } finally {
      setPending(false);
    }
  }

  if (!token) {
    return (
      <AuthCard title="Lien invalide">
        <Alert message="Le lien de réinitialisation est incomplet." />
        <Link className="btn btn-secondary" to="/mot-de-passe-oublie">
          Demander un nouveau lien
        </Link>
      </AuthCard>
    );
  }

  return (
    <AuthCard title="Nouveau mot de passe" subtitle="Toutes vos sessions seront déconnectées.">
      <Alert message={error} />
      {done ? (
        <>
          <Alert message="Mot de passe mis à jour." variant="success" />
          <Link className="btn btn-secondary" to="/login">
            Se connecter
          </Link>
        </>
      ) : (
        <form onSubmit={handleSubmit}>
          <NouveauMotDePasse label="Nouveau mot de passe" />
          <button className="btn" type="submit" disabled={pending}>
            {pending ? 'Enregistrement…' : 'Enregistrer'}
          </button>
        </form>
      )}
    </AuthCard>
  );
}
